<template>

	<div :class="{'form-input-wrap': true, 'no-margin-bottom': noMarginBottom }">

		<div class="label-wrap" v-if="['checkbox','radio'].indexOf(theType())<0&&!!label">

			<label v-if="label" v-html="label" :style="labelStyles" class="input-label" />

		</div>

		<div 
			:class="{ 'input-wrap-wrap': true, check: ['checkbox','radio'].indexOf(theType())>=0, 'inner-error':!!innerError }"
		>

			<Tip
				v-if="tip"
				position="fromRight"
			>{{ tip }}</Tip>

			<span class="inner-error" v-if="innerError" v-html="innerError" />

			<input 
				v-if="['text','email','password','tel','search'].indexOf(theType())>=0"
				:class="[{'has-error': ( !!hasError && !emptyError && !innerError ), required: required, 'has-tip': tip!==''},classes2]"
				:type="theType()" 
				:name="name"
				:id="id"
				:value="value"
	      		@input="$emit('input', $event.target.value); errorCheck"
				@keyup="keyuped"
				@change="errorCheck"
				@blur="blurred"
				@focus="focussed"
				:placeholder="placeholder"
				:disabled="disabled"
				:autocomplete="autocomplete"
				@keyup.enter="emitKeyUp"
				@keyup.esc="emitKeyUp('esc')"
				:ref="theRef"
			/>

			<input 
				v-if="['number'].indexOf(theType())>=0"
				:class="[{'has-error':( !!hasError && !emptyError ), required: required, 'has-tip': tip!==''},classes2]"
				:type="theType()" 
				:name="name"
				:id="id"
				:value="value"
	      		@input="$emit('input', $event.target.value); errorCheck"
				@keyup="errorCheck"
				@blur="blurred"
				@focus="focussed"
				@change="errorCheck"
				:placeholder="placeholder"
				:disabled="disabled"
				:min="min"
				:max="max"
				@keyup.enter="emitKeyUp('enter')"
				@keyup.esc="emitKeyUp('esc')"
				:ref="theRef"
				:autocomplete="autocomplete"
			/>

			<div 
				:class="[{'has-error':( !!hasError && !emptyError ), required: required, 'date-filter-wrap': true},classes2]"
				v-if="['date'].indexOf(theType())>=0"
			>

				<DateFilter
					@change="setDate"
					@blur="blurred"
					@focus="focussed"
					:value="value"
					:placeholder="placeholder"
					mode="single"
					:ref="theRef"
				/>

			</div>

			<textarea
				v-if="theType()==='textarea'"
				:class="[{'has-error':( !!hasError && !emptyError ), required: required, 'has-tip': tip!=='','auto-resize':autoResize},classes2]"
				:type="theType()" 
				:name="name"
				:id="id"
				:value="value"
	      		@input="$emit('input', $event.target.value); errorCheck"
				@keyup="keyuped"
				@blur="blurred"
				@focus="focussed"
				@change="errorCheck"
				:placeholder="placeholder"
				:disabled="disabled"
				@keyup.enter="emitKeyUp('enter')"
				@keyup.esc="emitKeyUp('esc')"
				:ref="theRef"
				:rows="autoResize&&'2'"
				:autocomplete="autocomplete"
			/>

			<div 
				:class="[{'checkbox-wrap':true,inline:true},classes2]"
				v-if="(['checkbox','radio'].indexOf(theType())>=0 && items.length === 0 && typeof label !== 'undefined')"
			>

				<input 
					:class="[{'has-error':( !!hasError && !emptyError ), required: required},classes2]"
					:type="theType()" 
					:name="name"
					:id="id"
					:disabled="disabled"
					@click="clicked"
					v-model="checkRadioValue"
					:true-value="true"
					:false-value="false"
					:ref="theRef"
				/>

				<label :class="{'low-padding':lowLabelPadding}" :for="id" v-html="label" :style="labelStyles" v-if="label && ['checkbox','radio'].indexOf(theType())>=0" />

			</div>

			<div 
				v-for="(item, itemIndex) in processedItems" 
				:key="itemIndex"   
				:class="[{ 'checkbox-wrap' : true, inline: inline, tabbed: item.tabbed, disabled: item.disabled },classes2]" 
				:ref="theRef"
			>

				<input 
					:type="theType()" 
					:name="item.name"
					:id="item._id"
					:value="item.value"
					:disabled="item.disabled" 
					:checked="item.checked"
					@click="checked(itemIndex,$event)"
				/>

				<label :class="{'low-padding':lowLabelPadding}" :for="item._id" :style="[labelStyles,thisLabelStyles(item)]" v-html="item.label?item.label:'&nbsp;'" />

				<slot></slot>

				<Tip
					v-if="item.tip"
					position="fromRight"
				>{{ item.tip }}</Tip>

			</div>

		</div>

		<p 
			class="error single-input" 
			v-if="hasError && !emptyError && !showAsInnerError" 
			v-html="hasError" 
		/>

	</div>

</template>

<script>
import passwordValidator from 'password-validator'
import Tip from './../Tip.vue'
import DateFilter from './../Data/DateFilter.vue'
export default {
	name: 'FormInput',
	components: {
		Tip,
		DateFilter
	},
	props: {
		type: String,
		errors: [String, Object, Array],
		value: {
			type: [String,Array,Number,Date,Boolean],
			default: ''
		},
		preName: {
			type: String,
			default: ''
		},
		ignoreEmpty: {
			type: Boolean,
			default: false
		},
		noMarginBottom: {
			type: Boolean,
			default: false
		},
		autocomplete: {
			type: String,
			default: ''
		},
		name: String,
		placeholder: {
			type: String,
			default: ''
		},
		id: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: true
		},
		inline: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		label: String,
		lowLabelPadding: {
			type: Boolean,
			default: false
		},
		min: {
			type: [String,Number],
			default: ''
		},
		max: {
			type: [String,Number],
			default: ''
		},
		items: {
			type: Array,
			default: function () { return []; }
		},
		tip: {
			type: String,
			default: ''
		},
		classes: {
			type: String,
			default: ''
		},
		labelStyles: {
			type: Object,
			default: function () { return {}; }
		},
		theRef: {
			type: String,
			default: ''
		},
		focus:{
			type: Boolean,
			default: false
		},
		autoResize: {
			type: Boolean,
			default: false
		},
		autoResizeMaxHeight: {
			type: Number,
			default: 0
		},
		heightBuffer: {
			type: Number,
			default: 0
		},
		fontSize: {
			type: String,
			default: ''
		}
	},
	data() {

		return {
			internalError: false,
			emptyError: false,
			checkRadioValue: false,
			hasFocus: false,
			showAsInnerError: false
		}

	},
	created () {
		if ( ['checkbox','radio'].indexOf(this.theType())>=0 ) this.checkRadioValue = this.value;
	},
	mounted() {
		if (this.theRef !== '') {
			this.$nextTick(() => {
				if (this.$refs[this.theRef]) {
					this.resizeTextarea();
					if ( this.focus ) this.$refs[this.theRef].focus();
				}
			});
		}
	},
	watch: { 
		checkRadioValue: { 
			immediate: false, 
			handler(newVal, oldVal) {
				if ( newVal !== oldVal ) this.$emit('input', newVal)
			} 
		},
		focus(newVal) {
			if (newVal && this.theRef !== '') {
				this.$nextTick(() => {
					if (this.$refs[this.theRef] && this.$refs[this.theRef].focus) {
						this.$refs[this.theRef].focus();
						if (this.$refs[this.theRef].select) {
							this.$refs[this.theRef].select();
						}
					}
				});
			}
		}
	},
	computed: {

		innerError () {

			if ( this.emptyError ) return 'Required';

			if ( this.showAsInnerError && this.internalError ) return this.internalError;

			return false;

		},

		classes2() {

			let classes = {};

			if ( this.classes !== '' ) {

				this.classes.split(' ').forEach( function (c) {

					classes[c] = true;

				});

			}

			if ( this.fontSize ) classes['font-size-'+this.fontSize] = true;

			classes['no-margin'] = this.noMarginBottom;

			classes['disabled'] = this.disabled;

			return classes;

		},

		valueComputed: {

			get: function () {
				return this.value
			},

			set: function (newValue) {
				this.value = newValue;
			}

		},

		processedItems () {

			let items = [];

			this.items.forEach ( function (item) {

				let i = {};

				if ( typeof item === 'string' ) {

					let id = ( this.preName ? ( this.preName + '-' ) : '' ) + item.toLowerCase().trim().replace(/ /g,"-"), 
						name = this.theType () === 'radio' ? this.name : id;

					i = { label: item, name: name, value: item, _id: id };

				}
				else {

					i = Object.assign({}, item );

					if ( this.theType() === 'checkbox' ) {

						if ( typeof i.name === 'undefined' ) i.name = i._id;

					}

					if ( this.theType() === 'radio' ) {

						if ( typeof i.name === 'undefined' ) i.name = this.id;

					}

					if ( this.theType() === 'checkbox' || this.theType() === 'radio' ) {

						i.checked = '';

						i.tabbed = !!item.tabbed;

						if ( this.value.indexOf( i.name ) >= 0 || item.checked ) {

							i.checked = 'checked';

						}

					}

					i._id = ( this.preName ? ( this.preName + '-' ) : '' ) + i._id;

				}

				items.push(i);

			}.bind(this));

			return items;

		},

		hasError() {

			if ( this.internalError || typeof this.errors === 'undefined' ) {

				return this.internalError;

			}

			let err = [];
			
			if ( typeof this.errors === 'object' && Array.isArray(this.errors) === false && typeof this.errors[this.name] !== 'undefined' ) {

				err = JSON.parse( JSON.stringify( this.errors[this.name] ) );

				err = typeof err.message !== 'undefined' ? err.message : err;

			}

			if ( Array.isArray(err) === false && err !== '' ) {

				err = [err];

			}

			if ( err.length > 0 ) {

				return err.join(', ');

			}

			return false;

		}

	},

	methods: {

		thisLabelStyles (item) {

			return item.styles || {};

		},

		clicked() {
			
			this.$emit('clicked');
			
		},

		keyuped ($event) {

			this.errorCheck();
			this.resizeTextarea ();
			this.emitIt('aKeyup',$event);

		},

		blurred () {

			this.hasFocus = false;
			this.errorCheck();
			this.resizeTextarea ();

		},
		focussed () {

			this.hasFocus = true;
			this.resizeTextarea ();

		},

		resizeTextarea () {

			if ( this.autoResize && this.theType() === 'textarea' && this.theRef !== '' ) {

				const textarea = this.$refs[this.theRef];
				textarea.style.height = '10px';
				const scrollHeight = textarea.scrollHeight + this.heightBuffer;
        		textarea.style.height = ( this.autoResizeMaxHeight > 0 && this.autoResizeMaxHeight <= scrollHeight ) ? ( this.autoResizeMaxHeight + 'px' ) : ( scrollHeight + 'px' );

			}

		},

		emitIt(type,ev) {

			this.$emit( type, ev );

		},

		emitKeyUp(type) {

			

		},

		action (a) {

			console.log(a);

		},

		setDate (info) {

			this.$emit('input',info);

		},

		checked ( itemIndex, event ) {

			let values = this.valueComputed, 
				index;
				
			if ( this.theType() === 'checkbox' ) {

				index = values.indexOf( this.processedItems[itemIndex].name );

				if ( event.target.checked ) {

					if ( index < 0 ) {

						values.push( this.processedItems[itemIndex].name );

					}

				}
				else if ( index !== -1 )  {

					values.splice(index, 1);

				}

			}
			else {

				this.processedItems.forEach ( function (item) {

					index = values.indexOf( item._id );

					if ( index > -1 )  {

						values.splice(index, 1);

					}

				});

				values.push( this.processedItems[itemIndex]._id );

			}
			
			this.valueComputed = values;

		},

		theType () {

			switch (this.type) {

				case 'url' :
					return 'text';

			}

			return this.type;

		},

		errorCheck () {

			try {

				this.$emit( 'keyup' );
				this.internalError = false;
				this.showAsInnerError = false;
				this.emptyError = false;
				const UrlPattern = require('url-pattern');
				const pattern = new UrlPattern('http(s)\\://(*.):domain.:tld(\\::port)(/*)');
				let match, empty = false;

				if ( this.required && this.value === '' ) {

					if ( !this.ignoreEmpty && !this.hasFocus ) {

						this.internalError = 'This field is required';

						this.emptyError = true;

					}

				}
				else {

					switch ( this.type ) {

						case 'email' :

							if ( this.hasFocus ) break;

							if ( /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test( this.value ) === false ) {

								this.internalError = 'Invalid email';
								this.showAsInnerError = true;

							}

						break;

						case 'url' :

							match = pattern.match( this.value );

							if ( match === null ) {

								this.internalError = 'Invalid URL';

								if ( this.value.length > 3 ) {

									if ( this.value.length > 7 && this.value.substring(0,8) !== 'https://' ) {

										this.internalError = "Must start with https://";

									}
									else {

										let c = this.value.split('://');

										if ( ( c[0].toLowerCase() === 'http' || c[0].toLowerCase() === 'https' ) && c[0].toLowerCase() !== c[0] ) {

											this.internalError = c[0] + ' must be lowercase';

										}

									}

								}

								this.showAsInnerError = true;

							}

						break;

						case 'password' :

							if ( this.hasFocus ) break;

							if ( this.value.length > 0 && this.value.length < 4 ) {

								this.internalError = 'Your password be at least 8 characters';

							}
							else {

								var passwordSchema = new passwordValidator();

								passwordSchema
									.is().min(8)                                    // Minimum length 8
									.is().max(30)                                  // Maximum length 100
									.has().uppercase()                              // Must have uppercase letters
									.has().lowercase()                              // Must have lowercase letters
									.has().digits()                                 // Must have digits
									.has().not().spaces()                           // Should not have spaces
									.is().not().oneOf(['Passw0rd', 'Password123']);

								var pwError = passwordSchema.validate(this.value, { list: true }), pwErrorList = [];

								if ( pwError.length > 0 ) {

									var pwErrorMessages = {
										min: 'be at least 8 characters',
										max: 'be at most 30 characters',
										digits: 'contain a number',
										uppercase: 'have an uppercase character',
										lowercase: 'have an lowercase character',
										spaces: "not contain spaces",
										oneOf: " be harder"
									};

									pwError.forEach( function (e) {
										if ( typeof pwErrorMessages[e] !== 'undefined' ) {

											pwErrorList.push(pwErrorMessages[e]);

										}
										else {
											console.log('missing ',e)
										}
									});

									this.internalError = 'Your password must ' + pwErrorList.join(', ');

								}

							}

						break;

					}

				}

				if ( this.internalError ) {

					setTimeout( function () { this.errorCheck() }.bind(this), 500 );

				}

				if ( this.required ) {

					this.$emit( 'has-internal-errors', { error: this.internalError, name: this.name, empty: empty } );

				}

				return true;

			}
			catch (err) {

				console.log('err',err);

			}

		}

	}
}
</script>
<style lang="less" scoped="true">
@import './../../assets/css/less/_settings.less';
@import './../../assets/css/less/_helper.less';

[type=text], [type=password], [type=submit], [type=email], [type=number], [type=search], textarea {

	border:none;
	background-color:@highlightGrey;
	.rounded(5px);
	margin-bottom: 30px;
	text-align: left;
	padding: 10px 18px;
	outline: none;
	width: 100%;
	font-size: 16px;
	font-weight: 500;
	line-height: 1;
	-webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

	&.font-weight-400 {
		font-weight: 400;
	}

	&.has-error {
		margin-bottom: 5px;
	}

	&.has-tip {
		padding-right: 34px;
	}

	&.no-margin {
		margin-bottom: 0;
	}

	&::placeholder {
		color: #777777;
	}

	&.disabled {
		cursor: not-allowed;
		.opacity(0.8);
	}

}

textarea {
	resize: none;
	line-height: 1.5em;
	min-height: 60px;
}

[type=search] {
	height: 35px;
}

[type=search] {
	background: @bgGrey url("data:image/svg+xml;utf8,<svg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M12.118 13.44a6.078 6.078 0 111.322-1.322l.017.017 1.815 1.815a.935.935 0 11-1.323 1.322l-1.814-1.814-.017-.017zm.756-4.907a4.341 4.341 0 11-8.683 0 4.341 4.341 0 018.683 0z' fill='@{darkContrastNoHash}'/><mask id='a' maskUnits='userSpaceOnUse' x='2' y='2' width='14' height='14'><path fill-rule='evenodd' clip-rule='evenodd' d='M12.118 13.44a6.078 6.078 0 111.322-1.322l.017.017 1.815 1.815a.935.935 0 11-1.323 1.322l-1.814-1.814-.017-.017zm.756-4.907a4.341 4.341 0 11-8.683 0 4.341 4.341 0 018.683 0z' fill='@{darkContrastNoHash}'/></mask><g mask='url(%23a)'><path fill='%238697A8' d='M0 0h18v18H0z'/></g></svg>") 10px center no-repeat;
	padding-left: 34px;
}

[type=checkbox], [type=radio] {

	&:not(old) {

		width   : 28px;
		margin  : 0;
		padding : 0;
		opacity : 0;
		position: absolute;

		& + label {

			display: inline-block;
			margin-left: 0;
			padding-left: 24px;
			line-height: 24px;
			position: relative;
			&:before {
				width: 18px;
				height: 18px;
				content: "";
				position: absolute;
				left: 0;
				top: 3px;
				background: url("data:image/svg+xml;utf8,<svg width='138' height='64' fill='none' xmlns='http://www.w3.org/2000/svg'><mask id='a' maskUnits='userSpaceOnUse' x='1' y='48' width='16' height='16'><rect x='1' y='48' width='16' height='16' rx='4' fill='%23C4C4C4'/></mask><g mask='url(%23a)'><path fill='@{formDefaultColourNoHash}' d='M1 48h16v16H1z'/></g><g filter='url(%23filter0_d)'><path fill-rule='evenodd' clip-rule='evenodd' d='M13.792 52.236a.758.758 0 01-.028 1.07l-6.06 5.758a.758.758 0 01-1.058-.013l-2.424-2.424a.758.758 0 011.071-1.072l1.902 1.902 5.526-5.249a.758.758 0 011.07.028z' fill='%23fff'/></g><path d='M133.381 4.299a.75.75 0 00-1.265.807l1.265-.807zm-3.479-1.41a.75.75 0 00.809-1.264l-.809 1.264zM133.25 9a7.25 7.25 0 01-7.25 7.25v1.5A8.75 8.75 0 00134.75 9h-1.5zM126 16.25A7.25 7.25 0 01118.75 9h-1.5a8.75 8.75 0 008.75 8.75v-1.5zM118.75 9A7.25 7.25 0 01126 1.75V.25A8.75 8.75 0 00117.25 9h1.5zm13.366-3.894A7.21 7.21 0 01133.25 9h1.5a8.71 8.71 0 00-1.369-4.701l-1.265.807zM126 1.75c1.438 0 2.776.418 3.902 1.139l.809-1.264A8.712 8.712 0 00126 .25v1.5z' fill='%23EAEDF0'/><g filter='url(%23filter1_d)'><path fill-rule='evenodd' clip-rule='evenodd' d='M135.027 2.429A.757.757 0 01135 3.5l-9.296 8.565a.758.758 0 01-1.058-.014l-2.424-2.424a.757.757 0 111.071-1.072l1.902 1.902 8.761-8.055a.758.758 0 011.071.027z' fill='%23B3C0CE'/></g><circle cx='68' cy='9' r='8' stroke='%23EAEDF0' stroke-width='1.5'/><path d='M16.38 4.299a.75.75 0 10-1.263.807l1.264-.807zm-3.478-1.41a.75.75 0 10.809-1.264l-.809 1.264zM16.25 9A7.25 7.25 0 019 16.25v1.5A8.75 8.75 0 0017.75 9h-1.5zM9 16.25A7.25 7.25 0 011.75 9H.25A8.75 8.75 0 009 17.75v-1.5zM1.75 9A7.25 7.25 0 019 1.75V.25A8.75 8.75 0 00.25 9h1.5zm13.367-3.894A7.212 7.212 0 0116.25 9h1.5a8.712 8.712 0 00-1.37-4.701l-1.263.807zM9 1.75c1.438 0 2.776.418 3.902 1.139l.809-1.264A8.713 8.713 0 009 .25v1.5z' fill='@{formDefaultColourNoHash}'/><g filter='url(%23filter2_d)'><path fill-rule='evenodd' clip-rule='evenodd' d='M18.027 2.429A.758.758 0 0118 3.5l-9.296 8.565a.758.758 0 01-1.058-.014L5.222 9.627a.758.758 0 011.071-1.072l1.902 1.902 8.761-8.055a.758.758 0 011.072.027z' fill='@{formDefaultColourNoHash}'/></g><mask id='b' maskUnits='userSpaceOnUse' x='57' y='48' width='16' height='16'><rect x='57' y='48' width='16' height='16' rx='4' fill='%23C4C4C4'/></mask><g mask='url(%23b)'><path fill='%23F8FAFB' d='M57 48h16v16H57z'/></g><mask id='c' maskUnits='userSpaceOnUse' x='57' y='48' width='16' height='16'><rect x='57.5' y='48.5' width='15' height='15' rx='3.5' stroke='%23F8FAFB'/></mask><g mask='url(%23c)'><path fill='%23EAEDF0' d='M57 48h16v16H57z'/></g><mask id='d' maskUnits='userSpaceOnUse' x='113' y='48' width='16' height='16'><rect x='113' y='48' width='16' height='16' rx='4' fill='%23C4C4C4'/></mask><g mask='url(%23d)'><path fill='%23F8FAFB' d='M113 48h16v16h-16z'/></g><mask id='e' maskUnits='userSpaceOnUse' x='113' y='48' width='16' height='16'><rect x='113.5' y='48.5' width='15' height='15' rx='3.5' stroke='%23F8FAFB'/></mask><g mask='url(%23e)'><path fill='%23EAEDF0' d='M113 48h16v16h-16z'/></g><g filter='url(%23filter3_d)'><path fill-rule='evenodd' clip-rule='evenodd' d='M125.792 52.236a.757.757 0 01-.028 1.07l-6.06 5.758a.758.758 0 01-1.058-.013l-2.424-2.424a.757.757 0 111.071-1.072l1.902 1.902 5.526-5.249a.758.758 0 011.071.028z' fill='%23B3C0CE'/></g><defs><filter id='filter0_d' x='2' y='51' width='14' height='11.273' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/><feOffset dy='1'/><feGaussianBlur stdDeviation='1'/><feColorMatrix values='0 0 0 0 0.266667 0 0 0 0 0.337255 0 0 0 0 0.423529 0 0 0 0.5 0'/><feBlend in2='BackgroundImageFix' result='effect1_dropShadow'/><feBlend in='SourceGraphic' in2='effect1_dropShadow' result='shape'/></filter><filter id='filter1_d' x='120' y='1.193' width='17.236' height='14.08' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/><feOffset dy='1'/><feGaussianBlur stdDeviation='1'/><feColorMatrix values='0 0 0 0 0.266667 0 0 0 0 0.337255 0 0 0 0 0.423529 0 0 0 0.25 0'/><feBlend in2='BackgroundImageFix' result='effect1_dropShadow'/><feBlend in='SourceGraphic' in2='effect1_dropShadow' result='shape'/></filter><filter id='filter2_d' x='3' y='1.193' width='17.236' height='14.08' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/><feOffset dy='1'/><feGaussianBlur stdDeviation='1'/><feColorMatrix values='0 0 0 0 0.266667 0 0 0 0 0.337255 0 0 0 0 0.423529 0 0 0 0.25 0'/><feBlend in2='BackgroundImageFix' result='effect1_dropShadow'/><feBlend in='SourceGraphic' in2='effect1_dropShadow' result='shape'/></filter><filter id='filter3_d' x='114' y='51' width='14' height='11.273' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/><feOffset dy='1'/><feGaussianBlur stdDeviation='1'/><feColorMatrix values='0 0 0 0 0.266667 0 0 0 0 0.337255 0 0 0 0 0.423529 0 0 0 0.25 0'/><feBlend in2='BackgroundImageFix' result='effect1_dropShadow'/><feBlend in='SourceGraphic' in2='effect1_dropShadow' result='shape'/></filter></defs></svg>") 0 0 no-repeat;
			}

		}

	}
		
}

[type=radio] {
	&:not(old) {
		& + label {
			&:before {
				background-position: -59px 0;
			}
		}
		&:checked {
			& + label {
				&:before {
					background-position: 0 0;
				}
			}
		}
	}
}
[type=checkbox] {
	&:not(old) {
		& + label {
			&:before {
				background-position: -57px -47px;
			}
		}
		&:checked {
			& + label {
				&:before {
					background-position: 0 -47px;
				}
			}
		}
	}
}

.checkbox-wrap {

	text-align: left;
	margin-top: 4px;
	position: relative;

	.tip {
		position: relative !important;
		top:auto !important;
		right: auto !important;
	}

	&.tabbed {
		
		padding-left: 26px;

	}

	label {

		display: inline;
		vertical-align: top;
	 	padding-top: 0px;
	 	font-size: 16px;
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Old versions of Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none;

	}

	&.disabled {

		label {

			.opacity(0.6);

		}

	}

	&.inline {

		display: inline-block;
		margin: 0 20px 0 0;

		&:last-child {
			
			margin-right: 0;

		}

	}

	&.font-size-14 {

		label {

			font-size: 14px;

		}

	}
	
}

.form-input-wrap {
	margin-bottom: 0;
	&.no-margin-bottom {
		label {
			padding-bottom: 0;
		}
	}
	&.no-margin {
		[type=text], [type=password], [type=submit], [type=email], [type=number], [type=search], textarea {
			margin-bottom: 0;
		}
	}
	&.inline {
		display: inline;
	}
	&.inline-block {
		display: inline-block;
	}
	&.checkbox-label-line-split {

		.checkbox-wrap {

			label {

				line-height: 1.15em;

			}

		}

	}
}

label {
	font-size: 14px;
    display: block;
    font-weight: normal;
    padding-bottom: 8px;
    .opacity(0.8);

	&.low-padding {
		padding-bottom: 4px;
	}
}

.date-filter-wrap, .v-select {
	margin-bottom: 30px;
	&.has-error {
		margin-bottom: 5px;
	}
}

textarea {

	height: 140px;

	&.two-row {

		height: 60px;

	}

	&.auto-resize {

		height: auto;

	}

}

[type=submit] {

	background-color: @formDefaultColour;
	color: #fff;
	padding:10px;
	margin:0 auto 14px;
	width: 100%;

	&:hover {

		background-color: #000;

	}

}
.input-wrap-wrap {
	position:relative;
	&.check {
		position: static;
		display: inline;
		label {
			display: inline-block;
		}
	}
	&.inner-error {
		position: relative;
		.vertical-align-parent;
		.inner-error {
			font-size: 10px;
			display: block;
			position: absolute;
			right: 8px;
			background-color: @formDefaultColour;
			color: #fff;
			.rounded(5px);
			padding: 3px 6px;
			right: 10px;
			.vertical-align;
		}
	}
	.tip {
		position:absolute;
		right: 0;
		top: 0px;
	}
}
</style>